<template>
  <div class="node-ticket-page">
    <Header
      :title="pageTitle"
      :showBack="!isFromDriver"
      :isFromDriver="isFromDriver"
    />

    <div class="node-ticket-summary bgfff">
      <div class="node-ticket-summary__name">{{ nodeName || "-" }}</div>
      <div class="node-ticket-summary__class" v-if="classDateText || classTimeText">
        <span>{{ classDateText }}</span>
        <span>{{ classTimeText }}</span>

        <div class="node-ticket-summary__meta c999">
          {{ nodeType === "arrival" ? "下车点" : "上车点" }} · 共
          {{ ticketList.length }} 张票
        </div>
      </div>
    </div>

    <div style="background-color: #fff">
      <!-- 筛选 -->
      <div class="statusfilter flex flex-justify-center" style="flex: 1">
        <van-checkbox name="a" icon-size="0.4rem" shape="square" v-model="bookTicketChecked"
                      @click="statusfilterClick('bookTicketChecked')">已订:&nbsp;{{ bookTicketCount }}</van-checkbox>
        <van-checkbox name="b" icon-size="0.4rem" shape="square" v-model="checkedChecked"
                      @click="statusfilterClick('checkedChecked')"><span style="color: green">已检:&nbsp;{{ checkedTickets
          }}/(含混检:{{ otherCheckedTickets }})</span>
        </van-checkbox>
        <van-checkbox name="c" icon-size="0.4rem" shape="square" v-model="uncheckedChecked"
                      @click="statusfilterClick('uncheckedChecked')"><span style="color: red">未检:&nbsp;{{ noCheckedCount
          }}</span></van-checkbox>
      </div>
    </div>

    <div class="wrap">
      <div v-if="loading" class="empty-tip">加载中...</div>
      <div v-else-if="!ticketList.length" class="empty-tip">暂无车票数据</div>
      <div v-else-if="!displayTicketList.length" class="empty-tip">暂无符合条件的车票</div>
      <div v-else class="infinite">
        <div
          class="list"
          v-for="item in displayTicketList"
          :key="item.OrderDetailGID"
        >
          <div class="passenger bgfff" @click="onTicketClick(item)">
            <van-row>
              <van-col span="24">
                <div class="custName">
                  <div class="birthday-flag" v-if="item.IsBirthday"></div>
                  {{ item.CustName }}({{ item.ticketTypeName }})
                  {{ item.IsChild ? "(携童)" : "" }}
                  <span style="color: red" v-if="item.TakingCount <= 1">
                    【首次】
                  </span>
                  <span v-else>【{{ item.TakingCount }}次】</span>
                  <span>【拨打{{ item.CallCount || 0 }}次】</span>
                  <span v-if="item.OrderTypeID == 2"> 【订】 </span>
                  <span style="color: red" v-if="item.CustTagNameList">
                    【{{ item.CustTagNameList }}】
                  </span>
                </div>
              </van-col>
            </van-row>
            <van-row>
              <van-col span="20">
                <van-row type="flex" :align="'center'" style="margin: 0.3rem 0">
                  <van-col span="10">
                    <a
                      v-if="item.CustTel && item.CustTel.length == 11"
                      class="flex tel-link"
                      :href="'tel:' + item.CustTel"
                      @click.stop
                    >
                      <span class="iconfont icondianhua"></span>
                      {{ item.CustTel }}
                    </a>
                    <span v-else>{{ item.CustTel || "-" }}</span>
                  </van-col>
                  <van-col span="14">
                    <div>
                      {{
                        nodeType === "arrival"
                          ? item.StartNodeName
                          : item.ArrivalNodeName
                      }}
                    </div>
                  </van-col>
                </van-row>
                <van-row>
                  <van-col span="10" v-if="item.PlatformName">
                    <div>平台:{{ item.PlatformName }}</div>
                  </van-col>
                  <van-col span="10" v-else>
                    <div>{{ item.BarCode }}</div>
                  </van-col>
                  <van-col span="14">
                    <div class="remark" v-if="item.Remark">
                      <van-popover
                        v-model="item.ShowRemarkPopover"
                        trigger="click"
                        placement="top"
                      >
                        <div class="remark-popover">
                          {{ item.Remark }}
                        </div>
                        <template #reference>
                          <div
                            class="flex"
                            @click.stop="item.ShowRemarkPopover = true"
                          >
                            <span class="line-limit-length">
                              备注:{{ item.Remark }}
                            </span>
                          </div>
                        </template>
                      </van-popover>
                    </div>
                  </van-col>
                </van-row>
              </van-col>
              <van-col span="4">
                <div class="w100 text-center" :class="ticketStatusClass(item)">
                  <div class="seat-no">
                    <span>{{ item.SeatNo }}</span>
                  </div>
                  <div class="status-text">
                    <span>{{ ticketStatus(item) }}</span>
                  </div>
                </div>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
    </div>

    <!-- 只读车票详情 -->
    <van-dialog
      v-model="showTicketInfo"
      title="车票详情"
      confirm-button-text="关闭"
      :show-cancel-button="false"
    >
      <div class="ticketContent-dialog" v-if="ticket">
        <van-cell title="线路" :value="ticket.LineName" />
        <van-cell
          title="班次"
          :value="(ticket.ClassDate || '') + ' ' + (ticket.ClassTime || '')"
        />
        <van-cell title="上车点" :value="ticket.StartNodeName" />
        <van-cell title="下车点" :value="ticket.ArrivalNodeName" />
        <van-cell
          title="订单类型"
          :value="getOrderType(ticket.OrderTypeID)"
        />
        <van-cell
          title="座号"
          :value="
            ticket.SeatNo +
            '(' +
            (ticket.BarCode ? ticket.BarCode : '未支付') +
            ')'
          "
        />
        <van-cell
          title="票价"
          :value="
            '￥' +
            ticket.TicketPrice +
            '(' +
            getTicketType(ticket.TicketTypeID) +
            ')'
          "
        />
        <van-cell
          v-if="ticket.StationFee"
          title="站务费"
          :value="'￥' + ticket.StationFee"
        />
        <van-cell title="支付方式" :value="ticket.PayTypeName || '-'" />
        <van-cell title="订单号" :value="ticket.OrderNo || '-'" />
        <van-cell title="号码">
          <template #default>
            <a
              v-if="ticket.CustTel && ticket.CustTel.length == 11"
              :href="'tel:' + ticket.CustTel"
              style="color: blue"
            >
              {{ ticket.CustTel }}
            </a>
            <span v-else>{{ ticket.CustTel || "-" }}</span>
            <span style="color: red"> ({{ ticket.CallCount || 0 }}次) </span>
          </template>
        </van-cell>
        <van-cell title="姓名" :value="ticket.CustName || '-'" />
        <van-cell title="证件类型" :value="ticket.CustCertType || '-'" />
        <van-cell title="证件号码" :value="ticket.CustCertNo || '-'" />
        <van-cell title="是否携童" :value="ticket.IsChild ? '是' : '否'" />
        <van-cell title="备注" :value="ticket.Remark || '-'" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";

export default {
  components: { Header },
  data() {
    return {
      loading: false,
      ticketList: [],
      ticket: null,
      showTicketInfo: false,
      lineClassDayGID: "",
      nodeGID: "",
      nodeName: "",
      // start | arrival
      nodeType: "start",
      classDate: "",
      classTime: "",
      // 司机端 WebView 带参进入
      isFromDriver: false,
      driverGID: "",
      driverToken: "",
      // 车票状态筛选
      bookTicketChecked: false,
      checkedChecked: false,
      uncheckedChecked: false,
    };
  },
  computed: {
    pageTitle() {
      return this.nodeType === "arrival" ? "下车点售票详情" : "上车点售票详情";
    },
    classDateText() {
      const fromTicket =
        this.ticketList.length > 0 && this.ticketList[0].ClassDate
          ? this.ticketList[0].ClassDate
          : "";
      const raw = fromTicket || this.classDate;
      if (!raw) return "";
      return this.$moment(raw).isValid()
        ? this.$moment(raw).format("YYYY-MM-DD")
        : String(raw).substr(0, 10);
    },
    classTimeText() {
      const fromTicket =
        this.ticketList.length > 0 && this.ticketList[0].ClassTime
          ? this.ticketList[0].ClassTime
          : "";
      const raw = fromTicket || this.classTime;
      if (!raw) return "";
      return String(raw).substr(0, 5);
    },
    // 已订票数
    bookTicketCount() {
      return this.ticketList.filter((t) => t.TicketStatusID === 4).length;
    },
    // 已检票数（含混检）
    checkedTickets() {
      return this.ticketList.filter((t) => [8, 9].indexOf(t.TicketStatusID) > -1).length;
    },
    // 混检票数
    otherCheckedTickets() {
      return this.ticketList.filter((t) => {
        const status = this.ticketStatus(t);
        return status === "混检" || status === "跨站点混检";
      }).length;
    },
    // 未检票数
    noCheckedCount() {
      return this.ticketList.filter((t) => t.TicketStatusID === 2).length;
    },
    // 前端过滤后的车票列表
    displayTicketList() {
      let list = this.ticketList;
      if (this.bookTicketChecked) {
        list = list.filter((t) => t.TicketStatusID === 4);
      } else if (this.checkedChecked) {
        list = list.filter((t) => [8, 9].indexOf(t.TicketStatusID) > -1);
      } else if (this.uncheckedChecked) {
        list = list.filter((t) => t.TicketStatusID === 2);
      }
      return list;
    },
  },
  async created() {
    this.parseRouteQuery();
    try {
      if (this.isFromDriver) {
        await this.initFromDriver();
      } else {
        this.fillClassDateFromCache();
      }
      await this.loadTicketList();
    } catch (e) {
      this.$toast.fail("初始化失败，请重试");
    }
  },
  methods: {
    /** 解析路由参数（兼容大小写，适配司机端 WebView） */
    parseRouteQuery() {
      const query = this.$route.query || {};
      for (const key in query) {
        const lowKey = String(key).toLowerCase();
        const val = query[key];
        switch (lowKey) {
          case "lineclassdaygid":
            this.lineClassDayGID = val || "";
            break;
          case "nodegid":
            this.nodeGID = val || "";
            break;
          case "nodename":
            try {
              this.nodeName = val ? decodeURIComponent(val) : "";
            } catch (e) {
              this.nodeName = val || "";
            }
            break;
          case "nodetype":
            this.nodeType =
              String(val).toLowerCase() === "arrival" ? "arrival" : "start";
            break;
          case "classdate":
            this.classDate = val || "";
            break;
          case "classtime":
            try {
              this.classTime = val ? decodeURIComponent(val) : "";
            } catch (e) {
              this.classTime = val || "";
            }
            break;
          case "drivergid":
            this.driverGID = val || "";
            break;
          case "token":
            this.driverToken = val || "";
            break;
          default:
            break;
        }
      }
      // 司机端：带 token + drivergid 视为司机 WebView 入口（对齐 TicketCheck）
      if (
        this.lineClassDayGID &&
        this.nodeGID &&
        this.driverGID &&
        this.driverToken
      ) {
        this.isFromDriver = true;
      }
    },
    fillClassDateFromCache() {
      if (this.classDate && this.classTime) return;
      try {
        const lcd = JSON.parse(
          window.localStorage.getItem("lineClassDay") || "null"
        );
        if (lcd) {
          if (!this.classDate && lcd.ClassDate) this.classDate = lcd.ClassDate;
          if (!this.classTime && lcd.ClassTime) this.classTime = lcd.ClassTime;
        }
      } catch (e) {
        // ignore
      }
    },
    /** 司机端：写入 token 并拉取用户信息（与 TicketCheck.getUserInfo 一致） */
    getUserInfo() {
      return new Promise((resolve, reject) => {
        window.localStorage.setItem(
          "adminInfo",
          JSON.stringify({
            GID: this.driverGID,
            CompGID: null,
          })
        );
        window.localStorage.setItem(
          "expireTime",
          new Date().getTime() + 1200000
        );
        window.localStorage.setItem("_cyw_token", this.driverToken);
        this.$http
          .post(this.$api.getUserInfo, this.$qs.stringify({}))
          .then((res) => {
            if (res.success) {
              resolve(res.data);
            } else {
              reject(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    /** 司机端：补全班次日期等信息 */
    getClassInfo() {
      return new Promise((resolve, reject) => {
        this.$http
          .post(
            this.$api.getLineClassDay,
            this.$qs.stringify({ GID: this.lineClassDayGID })
          )
          .then((res) => {
            if (res.success && res.data && res.data[0]) {
              const lcd = res.data[0];
              window.localStorage.setItem("lineClassDay", JSON.stringify(lcd));
              if (!this.classDate && lcd.ClassDate) {
                this.classDate = lcd.ClassDate;
              }
              if (!this.classTime && lcd.ClassTime) {
                this.classTime = lcd.ClassTime;
              }
              resolve(lcd);
            } else {
              resolve(null);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async initFromDriver() {
      const sysUserRes = await this.getUserInfo();
      window.localStorage.setItem(
        "adminInfo",
        JSON.stringify(sysUserRes.SysUser)
      );
      window.localStorage.setItem(
        "adminParams",
        JSON.stringify(sysUserRes.SysParams)
      );
      this.$store.commit("newCompInfo", {
        CompGID: sysUserRes.SysUser.CompGID,
        CompName: sysUserRes.SysUser.CompName,
      });
      await this.getClassInfo();
    },
    getOrderType(typeID) {
      const map = {
        1: "购票",
        2: "订",
        3: "往返套票",
        4: "小点订单",
        5: "货款订单",
      };
      return map[typeID] || "-";
    },
    getTicketType(typeID) {
      const map = {
        1: "全",
        2: "半",
        3: "优",
        4: "站务",
        5: "双程",
        6: "回程",
        7: "学生",
        8: "军残",
        9: "货款",
        11: "自定义",
      };
      return map[typeID] || "-";
    },
    ticketStatus(t) {
      switch (t.TicketStatusID) {
        case 2:
          return "未检";
        case 4:
          return "已订";
        case 8:
          if (
            this.nodeType === "start" &&
            t.StartNodeGID &&
            this.nodeGID &&
            t.StartNodeGID.toLowerCase() !== this.nodeGID.toLowerCase()
          ) {
            return "跨站点混检";
          }
          return "已检";
        case 9:
          return "混检";
        default:
          return "-";
      }
    },
    ticketStatusClass(t) {
      const result = ["ticketStatusBtn"];
      switch (this.ticketStatus(t)) {
        case "未检":
          result.push("danger");
          break;
        case "已订":
          result.push("default");
          break;
        case "跨站点混检":
        case "混检":
          result.push("primary");
          break;
        case "已检":
          result.push("success");
          break;
      }
      return result;
    },
    /**
     * LineClassDayTicketDetailQuery
     * 上车点传 StartNodeGID；下车点传 ArrivalNodeGID
     */
    loadTicketList() {
      if (!this.lineClassDayGID) {
        this.$toast("缺少班次信息");
        return Promise.resolve();
      }
      this.loading = true;
      const params = {
        LineClassDayGID: this.lineClassDayGID,
      };
      if (this.nodeType === "arrival" && this.nodeGID) {
        params.ArrivalNodeGID = this.nodeGID;
      } else if (this.nodeGID) {
        params.StartNodeGID = this.nodeGID;
      }

      return this.$http
        .post(this.$api.getTicketOrderDetai, this.$qs.stringify(params))
        .then((res) => {
          if (!res.success) {
            this.ticketList = [];
            return;
          }
          const list = res.data || [];
          this.ticketList = list.map((o) => ({
            ...o,
            ticketTypeName: this.getTicketType(o.TicketTypeID),
            ShowRemarkPopover: false,
          }));
        })
        .catch(() => {
          this.ticketList = [];
          this.$toast.fail("获取售票详情失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onTicketClick(item) {
      this.ticket = item;
      this.showTicketInfo = true;
    },
    // 车票状态筛选单击事件（互斥）
    statusfilterClick(name) {
      ["bookTicketChecked", "checkedChecked", "uncheckedChecked"]
          .filter((c) => c !== name)
          .forEach((i) => {
            this[i] = false;
          });
    },
  },
};
</script>

<style scoped lang="less">
.node-ticket-page {
  min-height: 100%;
  background: #f5f5f5;
  text-align: left;
}

.node-ticket-summary {
  padding: 0.3rem 0.4rem;
  border-bottom: 1px solid #eee;

  &__name {
    font-size: 0.5rem;
    font-weight: 600;
    color: #333;
  }

  &__class {
    margin-top: 0.1rem;
    font-size: 0.38rem;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 5px;
  }

  &__meta {
    font-size: 0.34rem;
    margin-left: 5px;
  }
}

.c999 {
  color: #999;
}

.bgfff {
  background: #fff;
}

.empty-tip {
  padding: 1.2rem 0;
  text-align: center;
  color: #999;
  font-size: 0.38rem;
}

.wrap {
  position: relative;
  width: 100%;
  margin: 0 auto;
  font-size: 0.4rem;
}

.infinite {
  width: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.list {
  width: 100%;
  padding: 0.1rem 0.15rem;
  box-sizing: border-box;

  .passenger {
    border-radius: 5px;
    padding: 0.2rem;
  }
}

.custName {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.tel-link {
  color: blue;
}

.line-limit-length {
  overflow: hidden;
  max-width: 3.2rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.remark-popover {
  width: 100%;
  background-color: #4a4a4a;
  color: white;
  font-size: 0.4rem;
  padding: 10px;
}

.seat-no {
  width: 100%;
  padding: 0.15rem 0;
  background-color: white;
  border-radius: 0.1rem 0.1rem 0 0;
}

.status-text {
  padding: 0.15rem 0;
  color: white;
}

.ticketStatusBtn {
  padding: 0.05rem;
  border-radius: 0.1rem;
  box-sizing: border-box;
}

.danger {
  background-color: #ee0a24;
}

.primary {
  background-color: #1989fa;
}

.success {
  background-color: #07c160;
}

.default {
  background-color: #cdcb9a;
}

.birthday-flag {
  border-radius: 50%;
  height: 5px;
  width: 5px;
  background: black;
  display: inline-block;
  transform: translateY(-50%);
  margin-right: 4px;
}

.ticketContent-dialog {
  max-height: 400px;
  overflow: auto;
}

.w100 {
  width: 100%;
}

.text-center {
  text-align: center;
}

.flex {
  display: flex;
  align-items: center;
}

.statusfilter {
  padding: 0.2rem 0.3rem;

  .van-checkbox {
    margin-right: 0.3rem;
  }
}
</style>
